import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import {
  DatepickerFieldInput,
  DatepickerFieldOutput,
} from '@trackback/widgets';
import { parseISO } from 'date-fns';
import { map } from 'rxjs/operators';
import { BaseFormControlWidgetComponent } from '../base-form-control-widget.component';
import { ParsePipe } from '../../pipes/parse.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Register('DatepickerField')
@Component({
  selector: 'tb-datepicker-field',
  templateUrl: './datepicker-field.component.html',
  styleUrls: ['./datepicker-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    AsyncPipe,
    ParsePipe,
  ],
})
export class DatepickerFieldComponent
  extends BaseFormControlWidgetComponent<
    DatepickerFieldInput,
    DatepickerFieldOutput
  >
  implements OnInit
{
  public _minDate: Date;
  public _maxDate: Date;

  constructor(injector: Injector) {
    super(injector);
  }

  protected externalToInternal(next?: string | null): Date | undefined | null {
    if (typeof next === 'string') {
      const date = parseISO(next);
      date.setHours(0, 0, 0, 0);
      return date;
    } else if (next === undefined || next === null) {
      return next;
    }
    return undefined;
  }

  protected internalToExternal(next?: Date): string {
    if (next) {
      return new Date(
        Date.UTC(
          next.getFullYear(),
          next.getMonth(),
          next.getDate(),
          0,
          0,
          0,
          0
        )
      ).toISOString();
    }
    return '';
  }

  async ngOnInit() {
    await super.ngOnInit();
    if (this.input.minDate) {
      this.parse(this.input.minDate)
        .pipe(map(minDate => this.externalToInternal(minDate)))
        .subscribe(minDate => {
          this._minDate = minDate;
        });
    }
    if (this.input.maxDate) {
      this.parse(this.input.maxDate)
        .pipe(map(maxDate => this.externalToInternal(maxDate)))
        .subscribe(maxDate => (this._maxDate = maxDate));
    }
  }
}
